export default __webpack_public_path__ + "static/media/bumrungrad-thai-logo.a5d6094e.png";